var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_1317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8482 2.91942L6.25504 7.27106C5.79765 7.7044 4.43992 7.90511 4.1366 7.61774C3.83328 7.33036 4.04031 6.04402 4.49769 5.61068L9.09566 1.25446C9.20904 1.13726 9.3463 1.04304 9.49922 0.977494C9.65208 0.911945 9.81741 0.876411 9.9852 0.873063C10.1529 0.86972 10.3197 0.898612 10.4754 0.958007C10.631 1.0174 10.7724 1.10608 10.8909 1.21866C11.0094 1.33123 11.1026 1.46539 11.1648 1.61302C11.2271 1.76067 11.2572 1.91872 11.2532 2.07767C11.2492 2.23661 11.2112 2.39316 11.1416 2.53783C11.072 2.68249 10.9722 2.81231 10.8482 2.91942Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89857 1.82458H3.49127C2.9805 1.82458 2.49069 2.01682 2.12952 2.359C1.76836 2.70118 1.56543 3.16527 1.56543 3.64918V8.21068C1.56543 8.69461 1.76836 9.15869 2.12952 9.50085C2.49069 9.84305 2.9805 10.0353 3.49127 10.0353H8.78734C9.85136 10.0353 10.2317 9.21421 10.2317 8.21068V5.92993",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.555,
    height: 10.9476,
    fill: "white",
    transform: "translate(0.602539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.00a7b28dce9170ab0e7dc0871816d127.svg";
export { ForwardRef as ReactComponent };